import { enGB, fi, sv } from 'date-fns/locale';
import { registerLocale } from 'react-datepicker';

import { DEFAULT_LANGUAGE } from './languages';

interface IDateLocale {
  // Name registered with react-datepicker.
  datePicker: string;
  // date-fns locale, e.g. for material-table's filter picker.
  dateFns: Locale;
  // date-fns format used by date inputs.
  dateFormat: string;
  // BCP 47 tag for Intl / toLocaleDateString.
  intl: string;
}

// English uses the British format so dates stay day-first with Monday as the first weekday.
const DATE_LOCALES: { [language: string]: IDateLocale } = {
  en: {
    datePicker: 'en-GB',
    dateFns: enGB,
    dateFormat: 'dd/MM/yyyy',
    intl: 'en-GB',
  },
  fi: {
    datePicker: 'fi',
    dateFns: fi,
    dateFormat: 'd.M.yyyy',
    intl: 'fi-FI',
  },
  // Swedish as written in Sweden: ISO dates (2026-10-09)
  sv: {
    datePicker: 'sv',
    dateFns: sv,
    dateFormat: 'yyyy-MM-dd',
    intl: 'sv-SE',
  },
};

export const getDateLocale = (language: string | undefined): IDateLocale =>
  DATE_LOCALES[language ?? ''] ?? DATE_LOCALES[DEFAULT_LANGUAGE];

export const registerDateLocales = (): void => {
  Object.values(DATE_LOCALES).forEach((locale) =>
    registerLocale(locale.datePicker, locale.dateFns)
  );
};
